/* 🤖 this file was generated by svg-to-ts */
export const matIconGasMeter: {
  name: 'gas-meter';
  data: string;
} = {
  name: 'gas-meter',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16 4h-1V2h-2v2h-2V2H9v2H8C5.79 4 4 5.79 4 8v10c0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4zm2 14c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v10z"/><path d="M9.5 15.54C9.5 16.9 10.62 18 12 18s2.5-1.1 2.5-2.46c0-1.09-.45-1.41-2.5-3.79-2.07 2.4-2.5 2.71-2.5 3.79zM8 8h8v2H8z"/></svg>`
};
